import React from "react";
import dataEn from "../../../languages/en/ninthSec";
import dataTh from "../../../languages/th/ninthSec";
import { useNavigate } from "react-router-dom";
const NinthSection = ({ language }) => {
  const navigate = useNavigate();
  const data = language === "en" ? dataEn : dataTh;

  return (
    <section
      className="h-70h flex flex-col md:flex-col-reverse lg:flex-row items-center  
     relative md:h-1200 lg:h-70h "
    >
      {/* Left Part */}
      <div
        className="w-full relative h-full
      lg:h-full lg:w-1/2
       "
      >
        {/* Overlay with gradient */}
        <div
          className="absolute top-0 left-0 w-full h-full  lg:w-full lg:h-full"
          style={{
            backgroundImage:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.5) 100%)",
          }}
        ></div>

        {/* Background image */}
        <div
          className="h-full relative flex flex-col justify-end lg:justify-center items-end w-full lg:h-full lg:w-full"
          style={{
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            zIndex: 1,
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover "
          >
            <source
              src={process.env.PUBLIC_URL + "/about%20us/gifMp4.webm"}
              type="video/mp4"
            />
            Your browser does not support HTML5 video.
          </video>

          {/* Text above the overlay */}
          <div className="relative h-full w-4/5  flex flex-col justify-end items-start mb-32 ml-3">
            <h2 className="text-lg  md:text-2xl font-bold mb-4 text-[#fffdfde8] text-left leading-4">
              {data.heading1}
              <span className="font-bold text-4xl opacity-100 text-white">
                {" "}
                {data.heading2}
              </span>{" "}
              <br />
              {data.heading3}
              <br />
              {data.heading4}
            </h2>
            <button
              className="mt-4 bg-primary-900 text-white font-bold py-3 px-6 rounded-full text-sm"
              onClick={() => navigate("/register")}
            >
              {data.btn}
            </button>
          </div>
        </div>
      </div>

      {/* Right Part */}
      <div
        className="hidden h-full w-full lg:h-full lg:w-1/2 bg-gray-300 md:flex flex-col p-8"
        style={{
          backgroundImage:
            "url(" + process.env.PUBLIC_URL + "/mian/pics/dashboard.png",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h2 className="text-2xl font-bold mt-16 ml-6 text-white text-left mb-2">
          {data.heading5}
        </h2>
        <h2 className="text-4xl font-bold ml-6 text-white text-left mb-2">
          {data.heading6}
        </h2>
        <h2 className="text-4xl font-bold ml-6 text-white text-left">
          {data.heading7}
        </h2>
      </div>
    </section>
  );
};

export default NinthSection;
